export default __webpack_public_path__ + "static/media/gear.6ec85c08.svg";